export default __webpack_public_path__ + "static/ACaslonPro-Regular-f14cde17022ae3180d95fe11b1b55b72.woff";